import { LocaleKeys } from '../../../../locale/translation-types'

export enum ProductTypeEnum {
  NORMAL = 'NORMAL',
  ONE_TO_ONE = 'ONE_TO_ONE',
  CLUB_FOUR = 'CLUB_FOUR',
  ONE_TO_ONE_INDIVIDUAL = 'ONE_TO_ONE_INDIVIDUAL'
}

type ProductOptions = {
  label: LocaleKeys
  title: LocaleKeys
}

export const productTypeEnumMapping: Record<ProductTypeEnum, ProductOptions> = {
  [ProductTypeEnum.NORMAL]: {
    label: 'product.type.enum.NORMAL.label',
    title: 'product.type.enum.NORMAL.title'
  },
  [ProductTypeEnum.ONE_TO_ONE]: {
    label: 'product.type.enum.ONE_TO_ONE.label',
    title: 'product.type.enum.ONE_TO_ONE.title'
  },
  [ProductTypeEnum.ONE_TO_ONE_INDIVIDUAL]: {
    label: 'product.type.enum.ONE_TO_ONE_INDIVIDUAL.label',
    title: 'product.type.enum.ONE_TO_ONE_INDIVIDUAL.title'
  },
  [ProductTypeEnum.CLUB_FOUR]: {
    label: 'product.type.enum.CLUB_FOUR.label',
    title: 'product.type.enum.CLUB_FOUR.title'
  }
}

export const productTypeOptions: Record<ProductTypeEnum, string> = Object.keys(
  ProductTypeEnum
).reduce(
  (acc, productType) => {
    const type = ProductTypeEnum[productType as keyof typeof ProductTypeEnum]
    acc[type] = productTypeEnumMapping[type].label
    return acc
  },
  {} as Record<ProductTypeEnum, string>
)
